import React from 'react'

const DirectoryCard = () => {
  return (
    <div className='w-[400px] md:w-[450px] bg-white rounded-md border border-slate-300 px-6 flex flex-col justify-start py-4 items-center gap-y-4'>
      <div className='w-28 h-28 overflow-hidden rounded-lg'>
        <img src="https://storage.googleapis.com/pokeprice-acd52.appspot.com/general/app-icon-small.png" className='w-28 h-28 object-cover' alt="" />
      </div>
      
      <p className='text-center text-sm'>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Expedita delectus sed et aperiam magni eum in maiores maxime repellat vel.
      </p>
      <p className='text-center text-sm'>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Expedita delectus sed et aperiam magni eum in maiores maxime repellat vel.
      </p>

      <div>
        <img src="https://storage.googleapis.com/pokeprice-acd52.appspot.com/general/pokedex-assets/discord-logo.png" className='h-11 w-auto' alt="" />
      </div>
    </div>
  )
}

export default DirectoryCard